(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentDialogController', VpPaymentDialogController);

    VpPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'VpPayment', 'Transaction', 'Customer'];

    function VpPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, VpPayment, Transaction, Customer) {
        var vm = this;

        vm.vpPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.transactions = Transaction.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vpPayment.id !== null) {
                VpPayment.update(vm.vpPayment, onSaveSuccess, onSaveError);
            } else {
                VpPayment.save(vm.vpPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:vpPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
